import { createFileRoute, Outlet, useNavigate, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';
import { AppShell, ShellSkeleton } from '../components/shell/app-shell';
import { ApiError } from '../lib/api';
import { useMe } from '../lib/session';

/**
 * Authenticated layout: every screen except login/MFA lives under /_app.
 * No session -> /login; session without a verified second factor -> /mfa (setup on first login).
 */
export const Route = createFileRoute('/_app')({
  component: AppLayout,
});

function AppLayout() {
  const { data: me, error, isLoading } = useMe();
  const navigate = useNavigate();
  const href = useRouterState({ select: (s) => s.location.href });

  useEffect(() => {
    if (error instanceof ApiError && error.status === 401) {
      void navigate({ to: '/login', search: { next: href } as never, replace: true });
    } else if (me && !me.mfaVerified) {
      void navigate({ to: '/mfa', search: { next: href, ...(me.mfaEnabled ? {} : { setup: 1 }) } as never, replace: true });
    }
  }, [error, me, href, navigate]);

  if (isLoading || !me || !me.mfaVerified) return <ShellSkeleton />;
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
